define(function(require) {
    return {
        MAP_TARGET_DECORATION_STYLE : {
            ID : "s_SERVICE_AREAS_DECORATION",
            SYMBOLIZERS : [
                {
                    SYMBOLIZER_TYPE : "SymbolPointSymbolizer",
                    COLOR : "rgba(255,255,255,1)",
                    FONT_NAME : "CartoVistaCartographic",
                    FONT_FILE_SOURCE : require("fonts/CartoVistaCartographic.ttf"),
                    SYMBOL_CHAR : ")",
                    HAS_DROP_SHADOW : true,
                    DROP_SHADOW_COLOR : "rgba(0,0,0,0.7)",
                    SIZE : 29,
                    OFFSET_X : -4,
                    OFFSET_Y : -13
                }, {
                    SYMBOLIZER_TYPE : "SymbolPointSymbolizer",
                    COLOR : "rgba(57,149,212,1)",
                    FONT_NAME : "CartoVistaCartographic",
                    FONT_FILE_SOURCE : require("fonts/CartoVistaCartographic.ttf"),
                    SYMBOL_CHAR : ")",
                    SIZE : 25,
                    OFFSET_X : -4,
                    OFFSET_Y : -14
                }
            ]
        }
    };
});
